import React from 'react';
import { Chip } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../hooks';

const SEVERITY_MAP: Record<string, Record<string, string>> = {
  'very high': { text: 'Very High', color: 'pink' },
  high: { text: 'High', color: 'orange' },
  medium: { text: 'Medium', color: 'warning' },
  low: { text: 'Low', color: 'brandSecondary' },
  'very low': { text: 'Very Low', color: 'success' },
  none: { text: 'None', color: 'neutral' },
} as const;

interface SodSeverityChipProps {
  text: string;
}

/**
 * For Severity chip
 */
function SodSeverityChip({ text }: SodSeverityChipProps) {
  const l = useInvertedLocalize();

  if (!text || !Object.keys(SEVERITY_MAP).includes(text.toLowerCase())) {
    return null;
  }

  const { text: label, color } = SEVERITY_MAP[text.toLowerCase()];

  return <Chip size='xSmall' kind='outlined' label={l(label)} color={color} />;
}

export default SodSeverityChip;
